var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaspLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.8945H12.9917C10.5315 21.8927 8.32198 20.9018 6.70664 19.2891C5.09494 17.6727 4.10466 15.4618 4.10285 13C4.10466 10.5382 5.09494 8.32727 6.70664 6.71091C8.32198 5.09818 10.5315 4.10727 12.9917 4.10546H20V1.6962e-06H12.9917C9.41038 -0.00181649 6.15063 1.45818 3.80485 3.80727C1.45726 6.15455 -0.00181533 9.41636 1.69512e-06 13C-0.00181533 16.5836 1.45726 19.8455 3.80485 22.1927C6.14881 24.5418 9.41038 26.0018 12.9917 26H20V21.8945Z",
    fill: "#20B2AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaspLogoSmall);
export default __webpack_public_path__ + "static/media/casp-logo-small.7c8105b23070bb1f80d9329189546c8e.svg";
export { ForwardRef as ReactComponent };